/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GuaranteeDto1Deductible } from './GuaranteeDto1Deductible';
import {
    GuaranteeDto1DeductibleFromJSON,
    GuaranteeDto1DeductibleFromJSONTyped,
    GuaranteeDto1DeductibleToJSON,
    GuaranteeDto1DeductibleToJSONTyped,
} from './GuaranteeDto1Deductible';

/**
 * 
 * @export
 * @interface GuaranteeDto1
 */
export interface GuaranteeDto1 {
    /**
     * Unique identifier of the guarantee product
     * @type {string}
     * @memberof GuaranteeDto1
     */
    id: string;
    /**
     * Unique identifier of the guarantee product
     * @type {string}
     * @memberof GuaranteeDto1
     */
    guaranteeTunnelId: string;
    /**
     * Name of the guarantee
     * @type {string}
     * @memberof GuaranteeDto1
     */
    name: string;
    /**
     * Short name of the guarantee
     * @type {string}
     * @memberof GuaranteeDto1
     */
    shortName?: string;
    /**
     * Short description of the guarantee
     * @type {string}
     * @memberof GuaranteeDto1
     */
    shortDescription?: string;
    /**
     * Long description of the guarantee
     * @type {string}
     * @memberof GuaranteeDto1
     */
    longDescription?: string;
    /**
     * Indicates if the guarantee is required
     * @type {boolean}
     * @memberof GuaranteeDto1
     */
    isRequired: boolean;
    /**
     * 
     * @type {string}
     * @memberof GuaranteeDto1
     */
    warningMessage?: string;
    /**
     * 
     * @type {GuaranteeDto1Deductible}
     * @memberof GuaranteeDto1
     */
    deductible?: GuaranteeDto1Deductible;
    /**
     * 
     * @type {GuaranteeDto1Deductible}
     * @memberof GuaranteeDto1
     */
    ceiling?: GuaranteeDto1Deductible;
    /**
     * List of child guarantees
     * @type {Array<GuaranteeDto1>}
     * @memberof GuaranteeDto1
     */
    childrens?: Array<GuaranteeDto1>;
}

/**
 * Check if a given object implements the GuaranteeDto1 interface.
 */
export function instanceOfGuaranteeDto1(value: object): value is GuaranteeDto1 {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('guaranteeTunnelId' in value) || value['guaranteeTunnelId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isRequired' in value) || value['isRequired'] === undefined) return false;
    return true;
}

export function GuaranteeDto1FromJSON(json: any): GuaranteeDto1 {
    return GuaranteeDto1FromJSONTyped(json, false);
}

export function GuaranteeDto1FromJSONTyped(json: any, ignoreDiscriminator: boolean): GuaranteeDto1 {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'guaranteeTunnelId': json['guaranteeTunnelId'],
        'name': json['name'],
        'shortName': json['shortName'] == null ? undefined : json['shortName'],
        'shortDescription': json['shortDescription'] == null ? undefined : json['shortDescription'],
        'longDescription': json['longDescription'] == null ? undefined : json['longDescription'],
        'isRequired': json['isRequired'],
        'warningMessage': json['warningMessage'] == null ? undefined : json['warningMessage'],
        'deductible': json['deductible'] == null ? undefined : GuaranteeDto1DeductibleFromJSON(json['deductible']),
        'ceiling': json['ceiling'] == null ? undefined : GuaranteeDto1DeductibleFromJSON(json['ceiling']),
        'childrens': json['childrens'] == null ? undefined : ((json['childrens'] as Array<any>).map(GuaranteeDto1FromJSON)),
    };
}

export function GuaranteeDto1ToJSON(json: any): GuaranteeDto1 {
    return GuaranteeDto1ToJSONTyped(json, false);
}

export function GuaranteeDto1ToJSONTyped(value?: GuaranteeDto1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'guaranteeTunnelId': value['guaranteeTunnelId'],
        'name': value['name'],
        'shortName': value['shortName'],
        'shortDescription': value['shortDescription'],
        'longDescription': value['longDescription'],
        'isRequired': value['isRequired'],
        'warningMessage': value['warningMessage'],
        'deductible': GuaranteeDto1DeductibleToJSON(value['deductible']),
        'ceiling': GuaranteeDto1DeductibleToJSON(value['ceiling']),
        'childrens': value['childrens'] == null ? undefined : ((value['childrens'] as Array<any>).map(GuaranteeDto1ToJSON)),
    };
}

